import { spring, } from "motion-dom";
import { createAnimationsFromSequence } from "../sequence/create";
import { animateSubject } from "./subject";
export function animateSequence(sequence, options, scope) {
    const animations = [];
    const animationDefinitions = createAnimationsFromSequence(sequence, options, scope, { spring });
    animationDefinitions.forEach(({ keyframes, transition }, subject) => {
        animations.push(...animateSubject(subject, keyframes, transition));
    });
    return animations;
}
//# sourceMappingURL=sequence.js.map